import React from "react";
import videos from "../../utils/videos";
const Videos = () => {
  return (
    <div>
      <div className='card-header d-flex justify-content-center custom-btn-color' style={{width:'100%',borderRadius:0}}>
        <h3 className='font-family' style={{ color: "#FFF", fontWeight: 600 }}>
          Demonstration Videos
        </h3>
      </div>
      <div className='d-flex flex-wrap mt-3 ml-5' style={{ gap: 10 }}>
        {videos.map((video,index) => (
          <div key={index}>
            <div
              className="video-container"
              style={{
                backgroundColor: "#7f959f",
                borderRadius: 5,
                padding: 10,
              }}
            >
              <video controls height={200} width={280}>
                <source src={video.src} type='video/mp4' />
                Can not play video.
              </video>
            </div>
            <p className='video-description'>{video.descrption}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Videos;
